import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e060d09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { for: "confidenzialità" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_6 = {
  class: "form",
  style: {"margin-top":"2%"}
}
const _hoisted_7 = { for: "confidenzialità" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "tags"
}
const _hoisted_12 = ["checked"]
const _hoisted_13 = { style: {"display":"inline-block"} }
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = { style: {"display":"inline-block"} }
const _hoisted_16 = { class: "flex justify-between" }

import { Associated, TblTerapie } from "@/../../EshJSLib/models/patient";
import { FaramaciCollection } from "@/../../EshJSLib/models/farmaciModel";
import { Farmaci } from "@/../../EshJSLib/models/farmaciModel";
import { filterFarmaci } from "@/../../EshJSLib/services/farmaciServices";
import { onMounted, reactive } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { Modal } from "flowbite-vue";
import * as model from "@/../../EshJSLib/models/patient";
import { getLiveliVisibilita } from "@../../../../EshJSLib/services/EshLOV";


export default /*#__PURE__*/_defineComponent({
  __name: 'dottoriAggiuntiveEdit',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit }) {

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const store = patientStore();
const { patient } = storeToRefs(store);
let farmacoSrc = ref(false);
let terapienew = ref({} as TblTerapie);
const alertConfirmMessage = ref<null | string>(null);
const showConfirm = ref(false);
const farmacoSearch = ref("");
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
let isOpen = ref(false);
let filteredFarmaci = {} as FaramaciCollection;
let selectedarmaco = {} as Farmaci;
const filteredFarmaciReact = reactive(filteredFarmaci);
const mandatoryFields = ['assegnazione_confidenzialita', 'visibility', 'tags'];
let errors = ref([]);
let errorMessage = "Questo campo è obbligatorio!";
// let cppModel = reactive({ confidencialita: 0, visibility: 0, tags: [] });
let cppModel = reactive({} as Associated);
const ogTags = ref([]);
const liveliVisibilita = ref([] as model.EshDictionary[]);

onMounted(() => {
  errors.value = [];  
  initFlowbite();
});



function openModal(message: string, cppModelEdit: any): Promise<boolean> {
  errors.value = [];  
  cppModel = cppModelEdit;
  liveliVisibilita.value = getLiveliVisibilita();
  ogTags.value = cppModel.tags;
  alertConfirmMessage.value = message;
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });

}

function checkAll($event) {
  cppModel.tags = [];
  if ($event.target.checked) {
    for (let tag of patient.value.tag_medical_specialties) {
      const tagObject = { id_tag: tag.id, tag: tag.tag };
      cppModel.tags = cppModel.tags.concat(tagObject);
    }
  }
}

function checkTag($event, tag) {
  if (!$event.target.checked) {
    cppModel.tags = cppModel.tags.filter((cptag) => cptag.tag != tag.tag);
  } else {
    const tagObject = { id_tag: tag.id, tag: tag.tag };
    cppModel.tags = cppModel.tags.concat(tagObject);
  }
}



function saveChanges() {

  if( !validateFields() )   {   
      return;    
      }
  

  alertModal.value.openModal("Sei sicuro di salvare i dati?", true).then((userInput) => {

    if (userInput) {
      showConfirm.value = false;
      if (!resolvePromise) return;
         resolvePromise(true);
    }
  });

}

function validateFields(): boolean {
  let hasError = false;
  errors.value = [];
  if(mandatoryFields.includes('tags') && cppModel.visibility != 3) {
    mandatoryFields.pop();
  } else if (!mandatoryFields.includes('tags') && cppModel.visibility == 3) {
    mandatoryFields.push('tags');
  }
  mandatoryFields.forEach((field, index) => {
   
    if (!cppModel[field]) {
      hasError = true;
    
      errors.value.push(errorMessage);
    }
    else {
      errors.value.push("");

    }
  });

  if (hasError) {
    return false;
  }
  return true;
}




function closeModal() {
  showConfirm.value = false
  if (!resolvePromise) return;
         resolvePromise(false);
  emit("cancel");
  
}

function setTags() {
  if (cppModel.visibility != 3) {
    cppModel.tags = ogTags.value;
  }
}




__expose({ openModal });


return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        onClose: _cache[6] || (_cache[6] = ($event: any) => (closeModal()))
      }, {
        header: _withCtx(() => [
          _createVNode(AlertModal, {
            ref_key: "alertModal",
            ref: alertModal
          }, null, 512),
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("Seleziona il livello di confidenzialita: ")), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "confidenzialità",
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(cppModel).assegnazione_confidenzialita) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.id_livello_confidenzialita,
                  key: key
                }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_4))
              }), 128))
            ], 2), [
              [_vModelSelect, _unref(cppModel).assegnazione_confidenzialita]
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(errors)[0]), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t(" Livello di visibilità * ")), 1),
            _withDirectives(_createElementVNode("select", {
              id: "confidenzialità",
              class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(cppModel).visibility) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (setTags()))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveliVisibilita.value, (item, key) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.value,
                  key: key
                }, _toDisplayString(item.label), 9, _hoisted_8))
              }), 128))
            ], 34), [
              [_vModelSelect, _unref(cppModel).visibility]
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(errors)[1]), 1)
          ]),
          (_unref(cppModel).visibility == 3)
            ? (_openBlock(), _createElementBlock("label", _hoisted_10, _toDisplayString(_ctx.$t("tagLabel")), 1))
            : _createCommentVNode("", true),
          (_unref(cppModel).visibility == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("input", {
                  ref: "allCheck",
                  type: "checkbox",
                  style: {"display":"inline-block","margin-right":"5%","margin-left":"5%"},
                  checked: _unref(cppModel).tags.length == _unref(patient).tag_medical_specialties.length
            ,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (checkAll($event)))
                }, null, 40, _hoisted_12),
                _createElementVNode("h1", _hoisted_13, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t("allSelect")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).tag_medical_specialties, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"margin-left":"5%"},
                    key: tag.id
                  }, [
                    _createElementVNode("input", {
                      ref_for: true,
                      ref: 'tag' + tag.id,
                      type: "checkbox",
                      checked: JSON.stringify(_unref(cppModel).tags).includes(tag.tag),
                      style: {"display":"inline-block","margin-right":"5%"},
                      onChange: ($event: any) => (checkTag($event, tag))
                    }, null, 40, _hoisted_14),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(tag.tag), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (closeModal())),
              type: "button",
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            }, _toDisplayString(_ctx.$t("Annulla")), 1),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (saveChanges())),
              type: "button",
              class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            }, _toDisplayString(_ctx.$t("Salva")), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})